import AppService from "./AppService";

class ReportService{

    URL = 'report';
    
    constructor(){
        
    }

    /**
     * function for get data list from api
     * @param {*} endPoint
     * @param {*} data
     * @returns
     */
    getData(endPoint, data, param = {}){
        return AppService.loadGrid(this.URL + endPoint, data, param);
    }

    /**
     * function for add data
     * @param {*} endPoint 
     * @param {*} data 
     * @returns 
     */
    addData(endPoint, data){
        return AppService.addData(this.URL + endPoint, data);
    }

    /**
     * function for update data
     * @param {*} endPoint
     * @param {*} id
     * @param {*} data
     * @returns
     */
    updateData(endPoint, id, data){
        return AppService.updateData(this.URL + endPoint, id, data);
    }

    /**
     * function for delete data
     * @param {*} endPoint
     * @param {*} id
     * @returns
     */
    deleteData(endPoint, id){
        return AppService.deleteData(this.URL + endPoint, id);
    }

    post(endPoint, data){
        return AppService.post(this.URL + endPoint, data);
    }

    get(endPoint){
        return AppService.get(this.URL + endPoint);
    }

    getWithParam(endPoint, data){
        return AppService.getWithParam(this.URL + endPoint, data);
    }

    uploadFile(endPoint, data){
        return AppService.uploadFile(this.URL + endPoint, data);
    }

    downloadFile(endPoint, data){
        return AppService.downloadFile(this.URL + endPoint, data);
    }
}

export default new ReportService;